export const GENERATE_USER_API_TOKEN = 'GENERATE_USER_API_TOKEN';
export const GENERATE_USER_API_TOKEN_SUCCESS = 'GENERATE_USER_API_TOKEN_SUCCESS';
export const GENERATE_USER_API_TOKEN_FAILURE = 'GENERATE_USER_API_TOKEN_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/constants/generate_user_api_token.constants.js